import account from './account';
import cart from './cart';
import category from './category';
import home from './home';
import info from './info';
import intention from './intention';
import login from './login';
import orderDetail from './orderDetail';
import orderList from './orderList';
import productDetail from './productDetail';
import security from './security';
import userCenter from './userCenter';

export default {
  ...cart,
  ...productDetail,
  ...login,
  ...home,
  ...category,
  ...userCenter,
  ...account,
  ...intention,
  ...security,
  ...info,
  ...orderList,
  ...orderDetail,
};
